import { ButtonVariant } from '@/components/BaseLibrary/Button/Button';

const featureCardVariantMap: Record<string, ButtonVariant> = {
  Primary: ButtonVariant.PRIMARY,
  Secondary: ButtonVariant.SECONDARY,
  Tertiary: ButtonVariant.TERTIARY,
};

/**
 * Maps the `featureCard.variant` CMS field to a `ButtonVariant`. Returns
 * `undefined` for anything unset or unrecognized so `FeatureLink` falls back
 * to its own default instead of silently rendering an unstyled button.
 */
export function mapFeatureCardVariant(
  variant: string | undefined
): ButtonVariant | undefined {
  if (!variant) {
    return undefined;
  }

  return featureCardVariantMap[variant];
}
